// Import the isDev function from your utilities
import { isDev } from "@fuse/utils/DeviceDection"

// Assuming these environment variables return strings, we do not need to explicitly type them here
const USE_FORCE_LONG_POLLING = import.meta.env.VITE_USE_FORCE_LONG_POLLING
const USE_DEV_BACKEND = import.meta.env.VITE_USE_DEV_BACKEND
const USE_DEV_AUTH = import.meta.env.VITE_USE_DEV_AUTH
const DEV_ORIGIN = import.meta.env.VITE_DEV_ORIGIN
const FAKE_USER = import.meta.env.VITE_FAKE_USER
const SHOW_MIX_EM_UP_GENERATOR_CONTROLS = import.meta.env
  .VITE_SHOW_MIX_EM_UP_GENERATOR_CONTROLS
const DISABLE_LOGGING = import.meta.env.VITE_DISABLE_LOGGING
const SHOW_STORYBOOK = import.meta.env.VITE_SHOW_STORYBOOK

// Determine if we're in development mode
const isDevMode: boolean = isDev()

// Convert environment variable values to boolean
function toBool(value: string | boolean): boolean {
  return value === "true"
}

function isFalse(value: string | boolean): boolean {
  return value === "false"
}

// Define typed constants for your configuration flags
export const DEV = isDevMode
export const useForceLongPolling: boolean =
  isDevMode && toBool(USE_FORCE_LONG_POLLING)
export const useDevBackend: boolean = isDevMode && toBool(USE_DEV_BACKEND)
export const useDevAuth: boolean = isDevMode && toBool(USE_DEV_AUTH)
export const devOrigin: string | false =
  useDevBackend && !isFalse(DEV_ORIGIN) ? DEV_ORIGIN : false
export const fakeUser: boolean = toBool(FAKE_USER)
export const showMixEmUpGeneratorControls: boolean =
  isDevMode && toBool(SHOW_MIX_EM_UP_GENERATOR_CONTROLS)
export const showStorybook: boolean = isDevMode && toBool(SHOW_STORYBOOK)
export const disableLogging: boolean = toBool(DISABLE_LOGGING)

// Log configuration values to the console
console.log("@USE_FORCE_LONG_POLLING", USE_FORCE_LONG_POLLING)
console.log("@USE_DEV_BACKEND", USE_DEV_BACKEND)
console.log("@USE_DEV_AUTH", USE_DEV_AUTH)
console.log("@DEV_ORIGIN", DEV_ORIGIN)
console.log("@FAKE_USER", FAKE_USER)
console.log(
  "@SHOW_MIX_EM_UP_GENERATOR_CONTROLS",
  SHOW_MIX_EM_UP_GENERATOR_CONTROLS,
)
console.log("@DISABLE_LOGGING", DISABLE_LOGGING)

console.log("@Settings", {
  useForceLongPolling,
  useDevBackend,
  useDevAuth,
  devOrigin,
  fakeUser,
  showMixEmUpGeneratorControls,
  showStorybook,
})

// Override console methods if logging is disabled
// if (disableLogging) {
//   console.log = () => {}
//   console.warn = () => {}
//   console.error = () => {}
//   console.info = () => {}
//   // You might use console.debug for development-specific logs, as shown in the comment.
//   // console.debug is stripped out in production builds by default.
// }
